"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utilities = require("../../utilities");

var _Snippets = _interopRequireDefault(require("./Snippets"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Kochava = {
  kochava: function kochava(args) {
    var snippets = _Snippets["default"].tags(args);

    var script = function script() {
      var element = document.createElement('script');
      element.innerHTML = snippets.script;
      return element;
    };

    return {
      script: script
    };
  },
  activity: function activity(event, data) {
    // tslint:disable-next-line
    typeof window !== 'undefined' && window.kochava && window.kochava.activity(event, data);
  },
  identity: function identity(_a) {
    var uniqueID = _a.uniqueID,
        marketingOptIn = _a.marketingOptIn; // tslint:disable-next-line

    typeof window !== 'undefined' && window.kochava && window.kochava.identify({
      uniqueID: uniqueID,
      marketingOptIn: marketingOptIn
    });
  },
  page: function page(name, data) {
    // tslint:disable-next-line
    typeof window !== 'undefined' && window.kochava && window.kochava.page(name, {
      data: data
    });
  },
  initialize: function initialize(settings) {
    // tslint:disable-next-line
    var kochava = this.kochava({
      key: settings.KEY,
      log: settings.LOG
    });
    var script = kochava.script();
    !(0, _utilities.doesScriptExist)(script) && document.head.insertBefore(script, document.head.childNodes[0]);
  }
};
var _default = Kochava;
exports["default"] = _default;